import './App.css'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import DisclosureDetail from './components/features/disclosure-detail/DisclosureDetail'
import DisclosureAdvanced from './components/features/disclosure-advanced/DisclosureAdvanced'
import Disclosures from './components/features/disclosures/Disclosures'
import PageNotFound from './components/PageNotFound'
import urls from './utils/constants/urls'

function App() {
    return (
        <BrowserRouter basename={urls.basename}>
            <Routes>
                <Route path="/advanced/" element={<DisclosureAdvanced />} />
                <Route path="/:id" element={<DisclosureDetail />} />
                <Route path="/" element={<Disclosures />} />
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App
